import React from 'react';
import { Toaster } from 'react-hot-toast';
import Nav from './Nav';
import FooterComponent from './FooterComponent';
import { AppContainer } from '../styles/layout';

function Layout({ children }) {
  return (
    <AppContainer>
      <Toaster position="top-right" />
      <Nav />
      {children}
      <FooterComponent />
    </AppContainer>
  );
}

export default Layout;
